"use strict";

import $ from "jquery";

export default class PermissionController {
  /*@ngInject*/
  constructor(
    screenSize,
    $rootScope,
    arrow,
    $location,
    LanguageService,
    Auth,
    $uibModal,
    $http,
    ProductAPI,
    Modal,
    gettextCatalog
  ) {
    "ngInject";
    $("#permission-tabset .nav-pills > li > a").addClass("btn-arrow-right");

    //Check if user language is the same than browser language
    Auth.getCurrentUser(undefined).then((user) => {
      //console.log(user);
      if (user.language !== LanguageService.lang) {
        $http
          .put("api/users/me", { language: LanguageService.lang })
          .catch((err) => {
            console.log("Error language");
          });
      }
    });

    var that = this;
    this.$location = $location;
    this.projectName = "Nouveau projet";
    this.arrow = arrow;
    this.Modal = Modal;
    this.ProductAPI = ProductAPI;
    this.gettextCatalog = gettextCatalog;
    //this.s = this.$location.search();
    arrow.getDirective();
    $rootScope.$on("$locationChangeSuccess", function () {
      arrow.getDirective();
    });
    var that = this;
    this.isMobile = screenSize.on("xs", function (match) {
      that.isMobile = match;
    });
    this.lang = LanguageService.lang;

    this.openDuplicate = function (demand) {
      let data = null;
      var modalInstance = $uibModal.open({
        windowClass: "modal-primary",
        animation: true,
        ariaLabelledBy: "modal-title",
        ariaDescribedBy: "modal-body",
        component: "duplicate",
        size: "lg",
        resolve: {
          products() {
            return that.products;
          },
          demand() {
            return demand;
          },
        },
      });

      //Traiter le resultat venant du popup
      modalInstance.result.then(
        function (data) {
          that.ProductAPI.save(data)
            .$promise.then((duplicata) => {
              duplicata = JSON.parse(JSON.stringify(duplicata));
              if (duplicata) {
                that.$location.path("/permission").search({
                  directive: "product",
                  project: duplicata.projectId,
                  demand: duplicata.id,
                });
                that.Modal.confirm.info(() => {})(
                  that.gettextCatalog.getString("Copie réussie"),
                  `${that.gettextCatalog.getString(
                    "Les auteurs et les œuvres ont bien été copiés dans la nouvelle demande"
                  )}.`,
                  that.gettextCatalog.getString("Fermer"),
                  "success"
                );
              }
              return;
            })
            .catch((err) => {
              let textError = "";
              if (err.status === 403) {
                textError = that.gettextCatalog
                  .getString(`Certains auteurs sélectionnés ne sont
              pas gérés pour cette type d'utilisation`);
              } else {
                textError = that.gettextCatalog
                  .getString(`Des problèmes sont survenus lors de la copie.
              Veuillez recommencer, si le problème persiste vous pouvez nous contacter directement.`);
              }
              that.Modal.confirm.info(() => {})(
                that.gettextCatalog.getString("Erreur"),
                textError,
                that.gettextCatalog.getString("Fermer"),
                "danger"
              );
              return;
            });
        },
        function () {}
      );
    };
  }

  duplicateConfirmedDemand() {
    var that = this;
    if (this.$location.search().demand) {
      this.disabledDuplicatedButton = true;
      that.ProductAPI.get({ id: parseInt(that.$location.search().demand) })
        .$promise.then((demand) => {
          that.demand = JSON.parse(JSON.stringify(demand));
          return that.ProductAPI.getModels().$promise.then(function (response) {
            that.disabledDuplicatedButton = false;
            that.products = JSON.parse(JSON.stringify(response));
            that.openDuplicate(that.demand);
            return;
          });
        })
        .catch(() => {
          console.log("---> Can't get demand"); // @@@ Popup with a error code go to board
          return null;
        });
    }
  }
  /*
  that.Modal.confirm.info(() => {})(that.gettextCatalog.getString('Chargement en cours'),
    that.gettextCatalog.getString(`Chargement des données en cours,
    veuillez réessayer dans quelques secondes.`), 'Fermer', 'danger');
  */

  openNewDemand() {
    let s = this.$location.search();
    if (s.project) {
      this.$location.path("/permission").search({
        project: s.project,
        directive: "product",
      });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/permission/permission.controller.js